import React from "react";
import { Chip } from "@mui/material";
import { lightTheme } from "../../styles/theme";

/** On a lesson whose steps a Creator can't follow. */
const ForAdminsTag: React.FC = () => (
  <Chip
    label="For admins"
    size="small"
    sx={{
      bgcolor: lightTheme.colors.warningSurface,
      color: lightTheme.colors.warningTextDark,
      fontWeight: 600,
      height: 22,
    }}
  />
);

export default ForAdminsTag;
